import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Header from './components/Header';
import LooksGallery from './components/LooksGallery';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import IntroAnimation from './components/IntroAnimation';

export default function Home() {
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="bg-[#0a0a0a] text-white">
      {!animationComplete && (
        <IntroAnimation onComplete={() => setAnimationComplete(true)} />
      )}
      
      <div className={`transition-opacity duration-1000 ${animationComplete ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <Header />
        <Hero />
        <LooksGallery />
        <Services />
        <About />
        <Contact />
      </div>
    </div>
  );
}
